// SwapFade — the previous layout's pictures, over the wall for one beat, fading out (`SwapFade.tsx`). It sits where the
// wall's rows sit: the same padding as `.wall` (`Wall.module.scss`), the rows placed inside it by their own offsets.

.layer {
    position: absolute;
    inset: 0;
    padding: 18px 22px;
    pointer-events: none;
    z-index: 2;
    animation-name: swapFadeOut;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
}

:global(html[data-wall-surface='sheet']) {
    .layer {
        padding: 8px 14px 0;
    }
}

.inner {
    position: relative;
}

.cell {
    position: absolute;
    object-fit: cover;
    display: block;
    border-radius: var(--tl-radius-art-xs);
    background: var(--tl-surface);
}

@keyframes swapFadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

@media (prefers-reduced-motion: reduce) {
    .layer {
        display: none;
    }
}
